import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { hide } from 'store/modules/modal';

export class SetChannelEventNameDialog extends Component {
  state = {
    name: '',
  };

  render() {
    const { opened, dispatch, handleOk } = this.props;

    return (
      <div>
        <Dialog open={opened} onClose={() => dispatch(hide())}>
          <DialogTitle>
            A Event is required to continue. Please give a name to the Event.
          </DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              id="eventName"
              label="Event Name"
              type="text"
              fullWidth
              autoFocus
              value={this.state.name}
              onChange={event => {
                this.setState({ name: event.target.value });
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                dispatch(hide());
              }}
              color="secondary"
            >
              CANCEL
            </Button>
            <Button
              onClick={() => {
                handleOk(this.state.name);
                dispatch(hide());
              }}
              color="primary"
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    opened: state.modal.opened,
  };
};

export default connect(mapStateToProps)(SetChannelEventNameDialog);
